export interface IDocusignEnvelopeVoidRequest {
        remoteEnvelopeId: string;
        reason: string;
    }

    export class DocusignEnvelopeVoidRequest implements IDocusignEnvelopeVoidRequest {
        remoteEnvelopeId: string;
        reason: string;

        constructor(remoteEnvelopeId: string, reason: string) {
            this.remoteEnvelopeId = remoteEnvelopeId;
            this.reason = reason;
        }
    }